import { Loading } from '@components/loadling';
import { Stack, Typography } from '@mui/material';
import { notistackRef } from '@proccess/ref/noti';
import { isAxiosError } from 'axios';

export function onApiError(error: unknown, show: boolean = true) {
  console.error('error', error);
  Loading.Hide();

  if (show) {
    if (isAxiosError<IApiError>(error)) {
      notistackRef.current?.enqueueSnackbar(
        <Stack direction={'column'}>
          <Typography fontSize={13} fontWeight={600}>
            {error.response?.data?.message || 'Có lỗi xảy ra!'}
          </Typography>
          <Typography fontSize={14} color="red" fontWeight={500}>
            {error.response?.data?.error_message || error.response?.status}
          </Typography>
        </Stack>,
        {
          variant: 'error',
        }
      );
    } else {
      notistackRef.current?.enqueueSnackbar('Có lỗi xảy ra!', { variant: 'error' });
    }
  }
}
